import { Component, inject, signal } from '@angular/core';
import { DataReaderService } from '@core/lp/data-reader.service';
import { LpInventoryComponent } from '@features/lp/lp-inventory/lp-inventory.component';
import { LpItem } from '@typings/lp/generated';

@Component({
  selector: 'app-inventory',
  imports: [LpInventoryComponent],
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.css',
})
export class InventoryComponent {
  readonly #dataReaderService = inject(DataReaderService);

  items = signal<LpItem[]>([]);

  constructor() {
    (async () => {
      const items = await this.#dataReaderService.getInstancesByType('Item');
      this.items.set(items);
    })();
  }
}
